import React from 'react';
import './ErrorModal.css';

const ErrorModal = ({ isOpen, onClose, title, message, details, type = 'error' }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      case 'success':
        return '✅';
      default:
        return '❌';
    }
  };

  const getTitle = () => {
    if (title) return title;
    switch (type) {
      case 'warning':
        return 'Warning';
      case 'info':
        return 'Information';
      case 'success':
        return 'Success';
      default:
        return 'Error';
    }
  };

  return (
    <div className="error-modal-overlay" onClick={onClose}>
      <div className="error-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="error-modal-header">
          <div className="error-modal-icon">{getIcon()}</div>
          <h2 className="error-modal-title">{getTitle()}</h2>
          <button className="error-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="error-modal-body">
          <p className="error-modal-message">{message}</p>
          {details && (
            <div className="error-modal-details">
              <details>
                <summary>Technical Details</summary>
                <pre>{typeof details === 'string' ? details : JSON.stringify(details, null, 2)}</pre>
              </details>
            </div>
          )}
        </div>
        <div className="error-modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;

